import { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'src/components/buttons/button';
import i18n from 'src/utils/translate';
import { showModal, closeModal } from 'src/modules/shared/modal/actions';
import { connect } from 'react-redux';
import { resendVerificationLink } from 'src/modules/shared/context/actions';
import { truncate } from 'underscore.string';

class VerificationBar extends Component {

  onResendEmailClick = () => {
    const { closeModal, resendVerificationLink } = this.props;
    resendVerificationLink();
    closeModal();
  }

  onInformationClick = () => {
    const { unverifiedEmail, showModal } = this.props;
    showModal({
      modalType: 'EMAIL_CONFIRMATION',
      modalProps: {
        unverifiedEmail,
        onResendEmailClick: this.onResendEmailClick,
      },
    });
  }

  render() {
    const { unverifiedEmail } = this.props;
    return (
      <div className="verification-bar">
        <div className="verification-bar__inner">
          <div className="verification-bar__copy">
            {i18n.t('Confirm your email by clicking the link we sent to %1$s').replace('%1$s', unverifiedEmail)}
            <span className="icon-information" onClick={this.onInformationClick} />
          </div>
          <div className="verification-bar__actions">
            <Button
              backgroundColor="#972C5C"
              border="1px solid white"
              text="Resend email"
              onClick={this.onResendEmailClick}
            />
            <a href="/settings">
              <Button
                backgroundColor="#972C5C"
                border="none"
                text="Change email"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const unverifiedEmail = state.context.currentUser ? state.context.currentUser.unverifiedEmail : '';
  return {
    unverifiedEmail: truncate(unverifiedEmail, 40),
  };
};

VerificationBar.propTypes = {
  unverifiedEmail: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, { showModal, closeModal, resendVerificationLink })(VerificationBar);
